import React, { useState, useEffect } from 'react';
import '../../../../../../styles/customer.css';
import '../../../../../../styles/style.css';
import axios from 'axios';
import toastr from 'toastr';
import ReactPaginate from 'react-paginate';
import { ToastContainer } from 'react-toastify';
import { LOGGED_IN_USER_URL } from '../../../../../../services/api/auth/AuthUrl';
import { ADMIN, NEW_PRODUCTS, SUPER_ADMIN } from '../../../../../../utils/departments/helpers';
import { useCustomers } from '../../../../../../hooks/new-products/products/wificall/customers/useCustomers';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import WifiCallNavBar from '../../../../../layouts/wificall/WifiCallNavBar';
import VerifiedCustomersBody from './VerifiedCustomersBody';

const VerifiedCustomers = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;

  const {
    verified,
    pages,
    filteredPages,
    isLoading,
    source,
    planType,
    handleSource,
    handlePlanType,
    handlePageClick,
    filterBySource,
    filterByAccountType,
    searchWithPhone,
  } = useCustomers();

  const [keyword, setKeyword] = useState('');
  const [searchField, setSearchField] = useState('phone');

  useEffect(() => {
    const checkDepartment = async () => {
      try {
        const response = await axios.get(`${LOGGED_IN_USER_URL}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        });

        if (
          response.data.department_id !== `${ADMIN}` &&
          response.data.department_id !== `${NEW_PRODUCTS}` &&
          response.data.department_id !== `${SUPER_ADMIN}`
        ) {
          sessionStorage.clear();
          history.push('/login');
          toastr.info('You are not allowed to view this page');
        }
      } catch (e) {}
    };

    checkDepartment();
  }, [history]);

  const searchWithParams = (e) => {
    e.preventDefault();

    if (!keyword.trim()) {
      toastr.info('Please enter a search value');
      return;
    }

    const cleanValue = keyword
      .replace(/\s+/g, ' ') // removes tabs, multiple spaces → single space
      .trim();

    const data = {
      [searchField]: cleanValue,
    };

    searchWithPhone(data);
  };

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <WifiCallNavBar currentPage="Customers" position={firstName} />

        <div className="row mt-5">
          <div className="col-12 pt-5 my-3">
            {/* SEARCH */}
            <form onSubmit={searchWithParams} className="ml-3 form-inline d-flex align-items-center">
              {/* DROPDOWN (DETERMINES FIELD) */}
              <select
                className="form-control mr-2"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
              >
                <option value="phone">Phone</option>
                <option value="email">Email</option>
                <option value="name">Name</option>
              </select>

              {/* INPUT */}
              <input
                className="form-control mr-2"
                value={keyword}
                type="text"
                placeholder={`Search by ${searchField}`}
                onChange={(e) => setKeyword(e.target.value)}
              />

              {/* BUTTON */}
              <button className="btn btn-primary">Search</button>
            </form>
          </div>

          <VerifiedCustomersBody
            customers={verified}
            isLoading={isLoading}
            filteredPages={filteredPages}
            filterBySource={filterBySource}
            filterByAccountType={filterByAccountType}
            source={source}
            handleSource={handleSource}
            planType={planType}
            handlePlanType={handlePlanType}
          />

          {pages > 1 ? (
            <ReactPaginate
              previousLabel="previous"
              nextLabel="next"
              pageCount={pages}
              onPageChange={handlePageClick}
              containerClassName="pagination"
              activeClassName="active"
            />
          ) : null}
        </div>
      </main>

      <ToastContainer />
    </div>
  );
};

export default VerifiedCustomers;
